module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-row', [_c('v-menu', {
    staticStyle: {
      "width": "100%",
      "z-index": "1001"
    },
    attrs: {
      "close-on-content-click": false,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-col', _vm._g({
          style: (("padding:1px; height: 44px; width: 100%; background-color: " + _vm.backgroundColor + "; border: 1px solid rgba(0, 0, 0, 0.5); border-radius: 4px; overflow: hidden;"))
        }, on), [(_vm.getQuery.or) ? _c('v-chip', {
          class: (" red " + _vm.tagTheme + " my-1 "),
          attrs: {
            "close": "",
            "disabled": _vm.disabled
          },
          on: {
            "input": function($event) {
              return _vm.searchOr(false)
            },
            "click:close": function($event) {
              return _vm.searchOr(false)
            }
          }
        }, [_vm._v("Or: " + _vm._s(_vm.getQuery.or) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getQuery.categoriesEmpty) ? [_c('v-chip', {
          staticClass: "blue darken-3 my-1",
          attrs: {
            "dark": "",
            "close": ""
          },
          on: {
            "input": _vm.searchCategoryEmptyToggle,
            "click:close": _vm.searchCategoryEmptyToggle
          }
        }, [_vm._v("Category: NULL")])] : _vm._l((_vm.getQuery.categories), function(cat, i) {
          return [_c('v-chip', {
            key: i + 1000,
            class: (" blue " + _vm.tagTheme + " my-1 "),
            attrs: {
              "close": ""
            },
            on: {
              "click:close": function($event) {
                return _vm.searchClearCateogry(i)
              },
              "input": function($event) {
                return _vm.searchClearCateogry(i)
              }
            }
          }, [_vm._v("Category: " + _vm._s(_vm.getCategoryName(cat.id)))])]
        }), _vm._v(" "), (_vm.getQuery.tagsEmpty) ? [_c('v-chip', {
          staticClass: "green darken-3 my-1",
          attrs: {
            "dark": "",
            "close": ""
          },
          on: {
            "input": _vm.searchTagEmptyToggle,
            "click:close": _vm.searchTagEmptyToggle
          }
        }, [_vm._v("Tag: NULL")])] : _vm._l((_vm.getQuery.tags), function(tag, i) {
          return [_c('v-chip', {
            key: i + 2000,
            class: (" green " + _vm.tagTheme + " my-1 "),
            attrs: {
              "close": ""
            },
            on: {
              "click:close": function($event) {
                return _vm.searchClearTag(i)
              },
              "input": function($event) {
                return _vm.searchClearTag(i)
              }
            }
          }, [_vm._v("Tag: " + _vm._s(tag))])]
        }), _vm._v(" "), (_vm.getQuery.uploader) ? [_c('v-chip', {
          class: (" pink " + _vm.tagTheme + " my-1 "),
          attrs: {
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.searchClearUploader()
            }
          }
        }, [_vm._v("Uploader: " + _vm._s(_vm.selectorUsername))])] : _vm._e(), _vm._v(" "), (_vm.getQuery.search) ? [_c('v-chip', {
          class: (" yellow darken-1 " + _vm.tagTheme + " my-1 "),
          attrs: {
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.searchClearPartial()
            }
          }
        }, [_vm._v("Search: " + _vm._s(_vm.getQuery.search))])] : _vm._e(), _vm._v(" "), (_vm.getQuery.dateStart) ? _c('v-chip', {
          class: (" yellow " + _vm.tagTheme + " my-1 "),
          attrs: {
            "close": "",
            "disabled": _vm.disabled
          },
          on: {
            "input": function () { return _vm.selector.dateStart = null; },
            "click:close": function () { return _vm.selector.dateStart = null; }
          }
        }, [_vm._v("Start: " + _vm._s(_vm.formatDate(_vm.getQuery.dateStart)) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getQuery.dateEnd) ? _c('v-chip', {
          class: (" orange " + _vm.tagTheme + " my-1 "),
          attrs: {
            "close": "",
            "disabled": _vm.disabled
          },
          on: {
            "input": function () { return _vm.selector.dateEnd = null; },
            "click:close": function () { return _vm.selector.dateEnd = null; }
          }
        }, [_vm._v("End: " + _vm._s(_vm.formatDate(_vm.getQuery.dateEnd)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-spacer')], 2)]
      }
    }]),
    model: {
      value: (_vm.showMenu),
      callback: function($$v) {
        _vm.showMenu = $$v
      },
      expression: "showMenu"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('div', {
    style: (("padding:0px; min-height: 0px; width: 100%; background-color: " + _vm.backgroundColor + "; border: 0px solid rgba(0, 0, 0, 0.5); border-radius: 4px;"))
  }, [(_vm.getQuery.or) ? _c('v-chip', {
    class: (" red " + _vm.tagTheme + " my-1 "),
    attrs: {
      "close": ""
    },
    on: {
      "input": function($event) {
        return _vm.searchOr(false)
      },
      "click:close": function($event) {
        return _vm.searchOr(false)
      }
    }
  }, [_vm._v("Or: " + _vm._s(_vm.getQuery.or) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.getQuery.categoriesEmpty) ? [_c('v-chip', {
    staticClass: "blue darken-3 my-1",
    attrs: {
      "dark": "",
      "close": ""
    },
    on: {
      "input": _vm.searchCategoryEmptyToggle,
      "click:close": _vm.searchCategoryEmptyToggle
    }
  }, [_vm._v("Category: NULL")])] : _vm._l((_vm.getQuery.categories), function(cat, i) {
    return [_c('v-chip', {
      key: i + 1000,
      class: (" blue " + _vm.tagTheme + " my-1 "),
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.searchClearCateogry(i)
        },
        "click:close": function($event) {
          return _vm.searchClearCateogry(i)
        }
      }
    }, [_vm._v("Category: " + _vm._s(_vm.getCategoryName(cat.id)))])]
  }), _vm._v(" "), (_vm.getQuery.tagsEmpty) ? [_c('v-chip', {
    staticClass: "green darken-3 my-1",
    attrs: {
      "dark": "",
      "close": ""
    },
    on: {
      "input": _vm.searchTagEmptyToggle,
      "click:close": _vm.searchTagEmptyToggle
    }
  }, [_vm._v("Tag: NULL")])] : _vm._l((_vm.getQuery.tags), function(tag, i) {
    return [_c('v-chip', {
      key: i + 2000,
      class: (" green " + _vm.tagTheme + " my-1 "),
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.searchClearTag(i)
        },
        "click:close": function($event) {
          return _vm.searchClearTag(i)
        }
      }
    }, [_vm._v("Tag: " + _vm._s(tag))])]
  }), _vm._v(" "), (_vm.getQuery.uploader) ? [_c('v-chip', {
    class: (" pink " + _vm.tagTheme + " my-1 "),
    attrs: {
      "close": ""
    },
    on: {
      "click:close": function($event) {
        return _vm.searchClearUploader()
      }
    }
  }, [_vm._v("Uploader: " + _vm._s(_vm.selectorUsername))])] : _vm._e(), _vm._v(" "), (_vm.getQuery.search) ? [_c('v-chip', {
    class: (" yellow darken-1 " + _vm.tagTheme + " my-1 "),
    attrs: {
      "close": ""
    },
    on: {
      "click:close": function($event) {
        return _vm.searchClearPartial()
      }
    }
  }, [_vm._v("Search: " + _vm._s(_vm.getQuery.search))])] : _vm._e(), _vm._v(" "), (_vm.getQuery.dateStart) ? _c('v-chip', {
    class: (" yellow " + _vm.tagTheme + " my-1 "),
    attrs: {
      "close": ""
    },
    on: {
      "input": function () { return _vm.selector.dateStart = null; },
      "click:close": function () { return _vm.selector.dateStart = null; }
    }
  }, [_vm._v("Start: " + _vm._s(_vm.formatDate(_vm.getQuery.dateStart)) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.getQuery.dateEnd) ? _c('v-chip', {
    class: (" orange " + _vm.tagTheme + " my-1 "),
    attrs: {
      "close": ""
    },
    on: {
      "input": function () { return _vm.selector.dateEnd = null; },
      "click:close": function () { return _vm.selector.dateEnd = null; }
    }
  }, [_vm._v("End: " + _vm._s(_vm.formatDate(_vm.getQuery.dateEnd)) + "\n          ")]) : _vm._e()], 2), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "search",
      "append-icon": "clear",
      "label": "Search",
      "hide-details": ""
    },
    on: {
      "click:append": function (event) { return _vm.localSearchClear(); },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return (function () { return _vm.searchText(_vm.selector.text); }).apply(null, arguments)
      }
    },
    model: {
      value: (_vm.selector.text),
      callback: function($$v) {
        _vm.$set(_vm.selector, "text", $$v)
      },
      expression: "selector.text"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "prepend-icon": "local_offer",
      "label": "Categories",
      "items": _vm.avaiableCategories,
      "hide-details": "",
      "item-value": "id",
      "item-text": "name",
      "no-data-text": "No available categories",
      "readonly": _vm.getQuery.categoriesEmpty,
      "return-object": ""
    },
    on: {
      "change": function () { return _vm.addCategory(_vm.selectorCategory); }
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                class: [{
                  'red--text': _vm.getQuery.categoriesEmpty
                }],
                on: {
                  "click": _vm.searchCategoryEmptyToggle
                }
              }, on), [_vm._v("block")])]
            }
          }])
        }, [_vm._v(" "), _c('span', [_vm._v("Search Images w/o Categories")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectorCategory),
      callback: function($$v) {
        _vm.selectorCategory = $$v
      },
      expression: "selectorCategory"
    }
  }), _vm._v(" "), _c('v-combobox', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "prepend-icon": "label",
      "label": "Tags",
      "items": _vm.avaiableTags,
      "item-text": "name",
      "hide-details": "",
      "no-data-text": "No available tags",
      "readonly": _vm.getQuery.tagsEmpty
    },
    on: {
      "change": function () { return _vm.addTag(_vm.selectorTag); }
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                class: [{
                  'red--text': _vm.getQuery.tagsEmpty
                }],
                on: {
                  "click": _vm.searchTagEmptyToggle
                }
              }, on), [_vm._v("block")])]
            }
          }])
        }, [_vm._v(" "), _c('span', [_vm._v("Search Images w/o Tags")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selectorTag),
      callback: function($$v) {
        _vm.selectorTag = $$v
      },
      expression: "selectorTag"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "prepend-icon": "account_circle",
      "label": "Uploader",
      "items": _vm.avaiableUploader,
      "item-text": "name",
      "hide-details": "",
      "no-data-text": "No uploaders",
      "readonly": _vm.getQuery.uploaderEmpty
    },
    on: {
      "change": function () { return _vm.addUploader(_vm.selectorUploader); }
    },
    model: {
      value: (_vm.selectorUploader),
      callback: function($$v) {
        _vm.selectorUploader = $$v
      },
      expression: "selectorUploader"
    }
  }), _vm._v(" "), _c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    staticStyle: {
      "padding-right": "8px"
    },
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('date-time-view', {
    attrs: {
      "clear": "",
      "label": "Start Date"
    },
    model: {
      value: (_vm.selector.dateStart),
      callback: function($$v) {
        _vm.$set(_vm.selector, "dateStart", $$v)
      },
      expression: "selector.dateStart"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "padding-right": "8px"
    },
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('date-time-view', {
    attrs: {
      "clear": "",
      "label": "End Date"
    },
    model: {
      value: (_vm.selector.dateEnd),
      callback: function($$v) {
        _vm.$set(_vm.selector, "dateEnd", $$v)
      },
      expression: "selector.dateEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "value": _vm.getQuery.or,
      "label": "Or query parameters together"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleOr.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.localSearchClear()
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": _vm.disabled
          },
          on: {
            "click": _vm.searchClear
          }
        }, on), [_c('v-icon', [_vm._v("clear")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Clear")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd78ab62","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBar.vue
// module id = 418
// module chunks = 1